import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from './components/shared.module';
import {CollaboratorFormatterPipe} from './pipe/collaborator-formatter.pipe';
import { MaterialModule } from './material-module';
import {EffectsModule} from '@ngrx/effects';
import {CoreEffects} from '@core/redux/core.effects';
import {StoreModule} from '@ngrx/store';
import * as fromCore from '@core/redux/core.reducer'
@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('core', fromCore.reducer),
    EffectsModule.forFeature([CoreEffects])
  ],
  exports: [SharedModule, CollaboratorFormatterPipe, MaterialModule],
  declarations: [CollaboratorFormatterPipe],
})
export class CoreModule {
}
